// // renderHighlightedText.jsx
// const renderHighlightedText = (text, highlights = []) => {
//   if (!text) return null
//   if (!highlights?.length) return <span>{text}</span>

//   const validHighlights = highlights.filter(h => h && typeof h === 'object' && h.start !== undefined)
//   if (!validHighlights.length) return <span>{text}</span>

//   const sorted = [...validHighlights].sort((a, b) => a.start - b.start)
//   const parts = []
//   let lastIndex = 0

//   sorted.forEach(({ start, end }, i) => {
//     if (start > lastIndex) {
//       parts.push(<span key={`text-${i}`}>{text.slice(lastIndex, start)}</span>)
//     }
//     parts.push(
//       <span key={`highlight-${i}`} style={{ color: 'orange' }}>
//         {text.slice(start, end)}
//       </span>
//     )
//     lastIndex = end
//   })

//   if (lastIndex < text.length) {
//     parts.push(<span key="text-end">{text.slice(lastIndex)}</span>)
//   }

//   return <>{parts}</>
// }

// export default renderHighlightedText



// const renderHighlightedText = (text, highlights = []) => {
//   if (!text) return null
//   if (!highlights?.length) return <span>{text}</span>

//   // Separate old string format from new object format
//   const stringHighlights = highlights.filter(h => typeof h === 'string' && h.trim())
//   const objectHighlights = highlights.filter(h => h && typeof h === 'object' && typeof h.start === 'number' && typeof h.end === 'number')

//   // Old format: plain strings — do simple inline replacement
//   if (stringHighlights.length > 0 && objectHighlights.length === 0) {
//     const escapedWords = stringHighlights.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
//     const pattern = new RegExp(`(${escapedWords.join('|')})`, 'gi')
//     const parts = text.split(pattern)
//     return (
//       <>
//         {parts.map((part, i) =>
//           stringHighlights.some(w => w.toLowerCase() === part.toLowerCase())
//             ? <span key={i} style={{ color: 'orange', fontWeight: 600 }}>{part}</span>
//             : <span key={i}>{part}</span>
//         )}
//       </>
//     )
//   }

//   // New format: offset-based objects
//   if (objectHighlights.length === 0) return <span>{text}</span>

//   const sorted = [...objectHighlights].sort((a, b) => a.start - b.start)
//   const parts = []
//   let lastIndex = 0

//   sorted.forEach(({ start, end }, i) => {
//     const safeStart = Math.max(start, lastIndex)
//     const safeEnd = Math.min(end, text.length)
//     if (safeStart >= safeEnd) return

//     if (safeStart > lastIndex) {
//       parts.push(<span key={`text-${i}`}>{text.slice(lastIndex, safeStart)}</span>)
//     }
//     parts.push(
//       <span key={`highlight-${i}`} style={{ color: 'orange', fontWeight: 600 }}>
//         {text.slice(safeStart, safeEnd)}
//       </span>
//     )
//     lastIndex = safeEnd
//   })

//   if (lastIndex < text.length) {
//     parts.push(<span key="text-end">{text.slice(lastIndex)}</span>)
//   }

//   return <>{parts}</>
// }

const renderHighlightedText = (text, highlights = []) => {
  if (!text) return null
  if (!highlights?.length) return <span>{text}</span>

  const objectHighlights = highlights.filter(
    h => h && typeof h === 'object' && typeof h.start === 'number' && typeof h.end === 'number'
  )

  // ✅ NEW: extract keyword strings from old { text: '...' } objects OR plain strings
  const keywordHighlights = highlights
    .filter(h => typeof h === 'string' && h.trim())
    .concat(
      highlights
        .filter(h => h && typeof h === 'object' && typeof h.text === 'string' && h.text.trim())
        .map(h => h.text)
    )

  // NEW format: offset-based objects — takes priority
  if (objectHighlights.length > 0) {
    const sorted = [...objectHighlights].sort((a, b) => a.start - b.start)
    const parts = []
    let lastIndex = 0

    sorted.forEach(({ start, end }, i) => {
      const safeStart = Math.max(start, lastIndex)
      const safeEnd = Math.min(end, text.length)
      if (safeStart >= safeEnd) return

      if (safeStart > lastIndex) {
        parts.push(<span key={`text-${i}`}>{text.slice(lastIndex, safeStart)}</span>)
      }
      parts.push(
        <span key={`highlight-${i}`} style={{ color: 'orange', fontWeight: 600 }}>
          {text.slice(safeStart, safeEnd)}
        </span>
      )
      lastIndex = safeEnd
    })

    if (lastIndex < text.length) {
      parts.push(<span key="text-end">{text.slice(lastIndex)}</span>)
    }

    return <>{parts}</>
  }

  // OLD format: plain strings OR { text: '...' } objects
  if (keywordHighlights.length > 0) {
    const escapedWords = keywordHighlights.map(w => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    const pattern = new RegExp(`(${escapedWords.join('|')})`, 'gi')
    const parts = text.split(pattern)
    return (
      <>
        {parts.map((part, i) =>
          keywordHighlights.some(w => w.toLowerCase() === part.toLowerCase())
            ? <span key={i} style={{ color: 'orange', fontWeight: 600 }}>{part}</span>
            : <span key={i}>{part}</span>
        )}
      </>
    )
  }

  return <span>{text}</span>
}

// Renamed stringHighlights → keywordHighlightsCovers both plain strings AND { text } objectsAdded .filter(h => h?.text).map(h => h.text) concatExtracts text from old-format { text: '...' } objectsOffset mode checks first, keyword mode is fallbackConsistent with renderHighlightedImpressionAsHtml priority logic



export default renderHighlightedText